import React, { useState } from 'react';
import { X } from 'lucide-react';

function ServiceFormModal({ service, onSave, onClose }) {
  const [formData, setFormData] = useState(service || {
    service_id: '',
    name: '',
    description: '',
    duration_minutes: 30,
    price: 0
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!service) {
      formData.service_id = `srv_${Date.now()}`;
    }
    onSave(formData);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{service ? 'Modifier le Service' : 'Nouveau Service'}</h2>
          <button onClick={onClose} className="modal-close">
            <X size={24} />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label>Nom du service *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label>Description *</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              rows="3"
              required
            />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Durée (minutes) *</label>
              <input
                type="number"
                value={formData.duration_minutes}
                onChange={(e) => setFormData({ ...formData, duration_minutes: parseInt(e.target.value) })}
                required
                min="5"
                step="5"
              />
            </div>
            <div className="form-group">
              <label>Prix (CDF) *</label>
              <input
                type="number"
                value={formData.price_cdf || formData.price || ''}
                onChange={(e) => setFormData({ ...formData, price_cdf: parseFloat(e.target.value), price: parseFloat(e.target.value) })}
                required
                min="0"
                step="1000"
                placeholder="Ex: 50000"
              />
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn-secondary">
              Annuler
            </button>
            <button type="submit" className="btn-primary">
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ServiceFormModal;
